<template>
    <div>
        <form-yes-no-radio-list 
          id="simInDevice" 
          v-model="simInDevice" 
          label="Did your device have a SIM in it at the time of the incident?"
          validationFieldLabel="simInDevice"
          validationInvalidFeedback="Please indicate whether your device had a SIM in it at the time of the incident">
        </form-yes-no-radio-list>
        <transition name="fade">
            <div v-if="simInDeviceNo">
                <form-text-area
                    v-model="reasonForNoSim" 
                    id="reasonForNoSim" 
                    validationFieldLabel="reasonForNoSim" 
                    :maxLength="500" 
                    label="Please indicate why there was no SIM in the device"
                    validationInvalidFeedback="Please provide details of why there was no SIM in the device"
                    rows="5">
                </form-text-area>
                <form-yes-no-radio-list 
                    id="everUsedWithSim" 
                    v-model="everUsedWithSim" 
                    label="Has the device ever been used with a SIM?"
                    validationFieldLabel="everUsedWithSim"
                    validationInvalidFeedback="Please indicate whether the device has ever been used with a SIM">
                </form-yes-no-radio-list>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="everUsedWithSimYes">
                <label for="lastUsedWithSimDate">Please indicate date last used with SIM</label>
                <date-picker id="lastUsedWithSimDate" 
                  fieldlabel="Last used date" 
                  :format="customDateFormatter" 
                  v-model="lastUsedWithSimDate" 
                  :disabled-dates="disabledDatesInFuture()" 
                  v-taurus-validator="'required'" />
                <div name="lastUsedWithSimDate" invalidfeedback="Please enter the date the device was last used with a SIM in the following format DD/MM/YYYY"></div>
                <label for="lastUsedWithSimDate">Please indicate date last used</label>
                <date-picker id="lastUsedDate" 
                  fieldlabel="Last used date with or without sim" 
                  :format="customDateFormatter" 
                  v-model="lastUsedDate" 
                  :disabled-dates="disabledDatesInFuture()" 
                  v-taurus-validator="'required'" />
                <div name="lastUsedDate" invalidfeedback="Please enter the date the device was last used in the following format DD/MM/YYYY"></div>
            </div>
        </transition>

    </div>
</template>
<script>
    import moment from 'moment'
    import FormYesNoRadioList from '@/components/FormYesNoRadioList.vue'
    import FormTextArea from '@/components/FormTextArea.vue'
    import DatePicker from '@/components/taurus-datepicker/components/Datepicker.vue'
    export default {
        props: {
            value: {
                required: false
            }
        },
        components: {
            FormYesNoRadioList,
            FormTextArea,
            DatePicker
        },
        mounted() {
            if (this.value) {
                if (this.value.hasOwnProperty('simInDevice')) {
                    this.simInDevice = this.value['simInDevice']
                }
                if (this.value.hasOwnProperty('reasonForNoSim')) {
                    this.reasonForNoSim = this.value['reasonForNoSim']
                }
                if (this.value.hasOwnProperty('everUsedWithSim')) {
                    this.everUsedWithSim = this.value['everUsedWithSim']
                }
                if (this.value.hasOwnProperty('lastUsedWithSimDate')) {
                    this.lastUsedWithSimDate = this.value['lastUsedWithSimDate']
                }
                if (this.value.hasOwnProperty('lastUsedDate')) {
                    this.lastUsedDate = this.value['lastUsedDate']
                }
            }
        },
        computed: {
            simInDeviceNo() {
                return this.simInDevice != null && this.simInDevice == false
            },
            everUsedWithSimYes() {
                return this.everUsedWithSim != null && this.everUsedWithSim == true
            }
        },
        watch:{
            simInDevice() {
                this.raiseInputEvent()
            },
            reasonForNoSim() {
                this.raiseInputEvent()
            },
            everUsedWithSim() {
                this.raiseInputEvent()
            },
            lastUsedWithSimDate() {
                this.raiseInputEvent()
            },
            lastUsedDate() {
                this.raiseInputEvent()
            }
        },
        data: () => {
            return {
                simInDevice: null,
                reasonForNoSim: null,
                everUsedWithSim: null,
                lastUsedWithSimDate: null,
                lastUsedDate: null
            }
        },
        methods: {
            disabledDatesInFuture () {
                return {
                    from: new Date()
                }
            },
            customDateFormatter (date) {
                return moment(date).format('DD/MM/YYYY')
            },
            raiseInputEvent() {
                let {simInDevice,
                    reasonForNoSim,
                    everUsedWithSim,
                    lastUsedWithSimDate,
                    lastUsedDate} = this

                const obj = {
                    simInDevice,
                    reasonForNoSim,
                    everUsedWithSim,
                    lastUsedWithSimDate,
                    lastUsedDate
                }
                this.$emit('input', obj)
            }
        }
    }
</script>